export enum Dds {
    Dom,
    Seg,
    Ter,
    Qua,
    Qui,
    Sex,
    Sab
}